import { createReducer, on } from '@ngrx/store';
import { identityCardActions } from '../identity_card.actions';

export interface CiExtractionState {
    state: 'pending' | 'loading' | 'loaded' | 'error';
}

export const initialState: CiExtractionState = { state: 'pending' };

export const ciExtractionReducer = createReducer(
    initialState,
    on(identityCardActions.extract, (state) => ({ ...state, state: 'loading' as const })),
    on(identityCardActions.extractSuccess, (state) => ({ ...state, state: 'loaded' as const })),
    on(identityCardActions.extractFail, (state) => ({ ...state, state: 'error' as const }))
);
